module.exports = __webpack_public_path__ + "static/ppwb_logo-7025f3d05ec2822207b81f911f4ce1c2.svg";